// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1pRbN","info":"Note_info__1lY-M","note":"Note_note__3u3Xl","actions":"Note_actions__1Igkl"};